import Footer from "../components/biggest/Footer";
import HowWork from "../components/biggest/HowWork";
import ListerPopuResidence from "../components/biggest/ListerPopuResidence";
import "../styles/pages_styles/listerResidenceFaq.css";

import { useEffect } from "react";
import FaqPart from "../components/biggest/FaqPart";
import { smoothScrollUp } from "../services/utils";
import { useStorePageManager } from "../store/PageManage";

export default function ListerResidenceFaq() {
  const handleUpdateFaqPage = useStorePageManager(
    (state) => state.handleUpdateFaqPage
  );
  handleUpdateFaqPage();
  useEffect(() => {
    let newTimeout = setTimeout(() => {
      smoothScrollUp(true);
    }, 100);
    return () => {
      clearTimeout(newTimeout);
    };
  }, []);
  return (
    <>
      {/* <Header /> */}
      <main>
        <ListerPopuResidence direct={true} />
        <HowWork />
        <FaqPart />
        <Footer />
      </main>
    </>
  );
}
